import { z } from 'zod';

/// ////////////////////////////////////////////
/// Model
/// ////////////////////////////////////////////

export const ContractorPaymentUploaderTemplate = z.object({
  csv: z.string().array().array(),
});
